module.exports = __webpack_public_path__ + "img/productcenter_img_en.96c33179.png";